<template>
    <div class="workbench-body">
        <slot/>
    </div>
</template>

<script>
export default {
  name: 'workbench-body'
}
</script>

<style lang="scss" scoped>
.workbench-body {
    height: calc(100% - 80px); // 减去头部栏
    overflow: auto;
    &::-webkit-scrollbar {
        // display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/workbench-body.vue